import React from 'react';

const VehicleTow = ({ imageSrc, paragraphText, paragraphText2, headerText }) => {
  return (
    <div className="journey-header section-one">
        {!headerText ?
            <div className="two-lines"> 
                <span className="arm">Get Road Side Assistance Anywhere and <br/>at Any Time of the Day - Secure Your <br/></span>
                <span className="journy">Journeys!</span> 
            </div>
        :
            <div className="two-lines"> 
                <span className="arm">{headerText}</span>
            </div>
        }
      <hr className="hrow" />
      <p className="parag">
        {paragraphText || 'Stuck on the road? stay calm and relaxed as help is just a call away with Roadside Assistance - anytime, anywhere, 24/7. It includes tyre replacement, towing, battery jumpstart, fuel delivery, key repair and accommodation assistance.'}
      </p>
      <p className="parag">
        {paragraphText2 || ''}
      </p>
      <div className="vehicle-img">
        <img
          src={imageSrc || `${process.env.PUBLIC_URL}/assets/vehicle-tow.svg`}
          alt="Truck"
          className="header-image-menu"
        />
      </div>
    </div>
  );
};

export default VehicleTow;
